import { render, staticRenderFns } from "./cpanel.vue?vue&type=template&id=53bd5a3c&"
import script from "./cpanel.vue?vue&type=script&lang=js&"
export * from "./cpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports